import { PartnerListItem } from "./PartnerListItem";

interface PartnerListProps {
  partners: {
    id: number;
    name: string;
  }[];
}

export const PartnersList = ({ partners }: PartnerListProps) => {
  return (
    <table className="table-content small-separate details">
      <thead>
        <tr>
          <th>Código</th>
          <th>Nome</th>
          <th>Status</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {partners?.length === 0 ? (
          <tr>
            <td colSpan={5} className="text-center text-purple">
              Oops! Parece que nada foi encontrado...
            </td>
          </tr>
        ) : (
          partners?.map((partner: any) => (
            <PartnerListItem partnerInfo={partner} key={partner.id} />
          ))
        )}
      </tbody>
    </table>
  );
};
